"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIcon = void 0;
var React = require("react");
exports.ArrowIcon = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 32" }, props, { className: "ap-arrow-svg" + (className ? " " + className : '') }),
        React.createElement("defs", null,
            React.createElement("polygon", { id: "a", points: "16.02 14 -8 14 -8 18 16.02 18 16.02 24 24 16 16.02 8" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { fill: "white" },
                React.createElement("use", { xlinkHref: "#a" })),
            React.createElement("use", { transform: "translate(8 16) rotate(-90) translate(-8 -16)", fill: "currentColor", fillRule: "nonzero", xlinkHref: "#a" }))));
};
{
    /* */
}
//# sourceMappingURL=ArrowIcon.js.map